import React from "react";

import "./styling/MainHeader.css";

const MainHeader = (props) => {
  return (
    <header 
      className="main-header" 
      onClick={props.onClick}
    >
      {props.children}
    </header>
  );
};

export default React.memo(MainHeader);
